var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout-home"
  }, [_c('div', {
    staticClass: "first-section"
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_1.png?t=20220713"),
      "alt": ""
    }
  }), _c('a', {
    staticClass: "cta-button",
    attrs: {
      "href": "https://www.momoshop.com.tw/category/MgrpCategory.jsp?m_code=2700400108&sourcePageType=4&osm=t04&utm_source=BD_010933&utm_medium=LINE-richmenu&scm_activity=202206240231ngevtn65",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/momo_home_cta_btn.png?t=20220623"),
      "alt": ""
    }
  })])]), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_2.png?t=20220713"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_3.png?t=20220713"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_4.png?t=20220713"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_5.png?t=20220713"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_6.png?t=20220713"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_7.png?t=20220713"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("./images/momo_home_bg_8.png?t=20220713"),
      "alt": ""
    }
  })]);
}]

export { render, staticRenderFns }